import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const topicModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#515475",
      borderRadius: 48,
    },
    content: {
      padding: 24,
      transition: "height 0.3s",
      "&:first-child": {
        paddingTop: 24,
      },
      "@media (max-width: 960px)": {
        padding: 6,
        "&:first-child": {
          paddingTop: 6,
        },
      },
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(3),
      top: theme.spacing(3),
      color: "white",
      backgroundColor: "#5db2e3",
      transition: "background-color 0.3s",
      borderRadius: "12px !important",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#5db2e3",
      },
    },
    centered: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    centeredMobile: {
      "@media (max-width: 600px)": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    column: {
      flexDirection: "column",
    },
    row: {
      flexDirection: "row",
      "@media (max-width: 720px)": {
        flexWrap: "wrap",
      },
    },
    relatedModulesText: {
      color: "white",
      fontSize: 24,
      fontWeight: "bold",
      "@media (max-width: 600px)": {
        fontSize: 22,
        width: "100%",
        textAlign: "center",
      },
    },
    relatedModulesContainer: {
      maxWidth: "100%",
      "@media (max-width: 600px)": {
        marginBottom: 24,
        marginTop: 12,
        width: "100%",
        justifyContent: "center !important",
      },
    },
    openModuleContainer: {
      paddingLeft: 24,
      "@media (max-width: 720px)": {
        paddingLeft: 0,
      },
    },
    ratingsContainer: {
      marginLeft: 16,
      "@media (max-width: 600px)": {
        marginLeft: 0,
        marginTop: 4,
      },
    },
    leftCentered: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
    },
    leftJustified: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "row",
    },
    centeredText: {
      textAlign: "center",
    },
    centeredTextMobile: {
      "@media (max-width: 600px)": {
        textAlign: "center",
      },
    },
    leftAligned: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    rightAligned: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    leftBottomAligned: {
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "flex-end",
    },
    iconContainer: {
      backgroundColor: "white",
      borderRadius: 12,
      height: 100,
      width: 100,
    },
    iconContainerRelated: {
      backgroundColor: "white",
      borderRadius: 12,
      height: 64,
      width: 64,
      marginLeft: 12,
      cursor: "pointer",
    },
    title: {
      fontSize: 40,
      color: "white",
      marginTop: 0,
      marginBottom: 4,
      fontWeight: "bold",
      "@media (max-width: 600px)": {
        textAlign: "center",
        marginBottom: 12,
        width: "100%",
      },
    },
    mortality: {
      color: "white",
      fontSize: 18,
      fontWeight: "bold",
    },
    question: {
      color: "white",
      fontSize: 24,
      fontWeight: "bold",
      width: "100%",
      marginBottom: 0,
    },
    starsFilled: {
      color: "white",
    },
    divider: {
      backgroundColor: "white",
      height: 2,
      width: "100%",
      margin: "24px 0",
    },
    dividerRight: {
      borderRight: "solid 2px white",
      "@media (max-width: 600px)": {
        borderRight: "0",
        borderBottom: "solid 2px white",
        marginBottom: 24,
        paddingBottom: 24,
      },
    },
    whiteText: {
      color: "white !important",
    },
    selectText: {
      color: "#515475",
      fontSize: 16,
    },
    selectBackground: {
      backgroundColor: "white !important",
      "&:focus": {
        backgroundColor: "white !important",
      },
    },
    inputBackground: {
      backgroundColor: "white !important",
      borderRadius: 24,
      "&:focus": {
        backgroundColor: "white !important",
      },
    },
    selectBorder: {
      "& fieldset": {
        borderColor: "white !important",
      },
    },
    stageOfChangeContainer: {
      backgroundColor: "white",
      borderRadius: 24,
      maxWidth: "70%",
      width: "100%",
      marginTop: 12,
      minHeight: 35,
    },
    stageOfChangeText: {
      color: "#515475",
      fontSize: 18,
      marginBottom: 0,
    },
    statsText: {
      color: "white",
      fontSize: 18,
      marginBottom: 0,
    },
    statsIcon: {
      marginRight: 12,
    },
    resultsTitle: {
      color: "white",
      fontSize: 32,
      marginBottom: 12,
    },
    score: {
      color: "white",
      fontSize: 64,
      fontWeight: "bold",
      lineHeight: 1,
      position: "relative",
      marginRight: 28,
      marginBottom: 0,
    },
    percentage: {
      fontSize: 28,
      position: "absolute",
      top: 6,
      right: -28,
    },
    rating: {
      fontSize: 18,
      color: "white",
      marginBottom: 0,
    },
    scoreContainer: {
      paddingBottom: 12,
      maxWidth: "85%",
      margin: "0 auto",
    },
    avgScoresRoot: {
      width: "100%",
    },
    avgScoresContainer: {
      width: "85%",
      border: "2px solid white",
      padding: "4px 4px",
      borderRadius: 16,
      margin: "0 auto",
    },
    resultsSubTitle: {
      color: "white",
      fontSize: 18,
      marginBottom: 0,
    },
    benchmarkIcon: {
      fontSize: 160,
      "@media (max-width: 600px)": {
        fontSize: 120,
      },
    },
    underline: {
      textDecoration: "underline",
      fontWeight: "bold",
    },

    bcgGridItemFirst: {
      backgroundColor: "white",
      borderRadius: 24,
    },
    bcgGridItem: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "column",
      minHeight: 100,
      padding: 24,
    },
    bcgButton: {
      fontSize: 18,
    },
    bcgText: {
      fontSize: 16,
      color: "white",
      marginTop: 12,
      padding: "0 16px",
    },
  })
);
